import React from 'react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import {
	MediaImageContainer,
	MediaSwiper,
	MediaSwiperContainer,
	MediaSwiperSlide,
} from './mediaStyles';
import { Media } from '../../../pages/innerPages/DELETEMEbookmarks';
import { checkImage, checkMedia } from '../../componentUtils';
import { v4 } from 'uuid';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';
import LoadingVideo from '../../Global/LoadingVideo/LoadingVideo';
import { BGTest } from '../../Global/styles';
import { BackgroundTest } from '../../Global/Icons/Icons';

type MediaModalProps = {
	media: Media[];
	activeIndex: number;
};
const MediaModal: React.FC<MediaModalProps> = ({ media, activeIndex }) => {
	return (
		<div>
			<div>
				<MediaSwiperContainer>
					<MediaSwiper
						centeredSlides={true}
						slidesPerView={1}
						initialSlide={activeIndex}
						pagination={{
							clickable: true,
						}}
						modules={[Pagination]}
						className="mySwiper styled-pagination">
						<BGTest>
							<BackgroundTest />
						</BGTest>

						{media.map((item) => {
							if (item.videoSrc) {
								return (
									<MediaSwiperSlide key={v4()}>
										<LoadingVideo
											src={checkMedia(
												item.videoSrc,
											)}></LoadingVideo>
									</MediaSwiperSlide>
								);
							} else {
								return (
									<MediaSwiperSlide key={v4()}>
										<MediaImageContainer>
											<LoadingImage
												src={checkImage(item.src)}
											/>
										</MediaImageContainer>
									</MediaSwiperSlide>
								);
							}
						})}
					</MediaSwiper>
				</MediaSwiperContainer>
			</div>
		</div>
	);
};

export default MediaModal;
